<div class="custom-dropdown" [class.is-open]="isOpen">
  <button type="button" class="dropdown-trigger" (click)="toggleOpen()">
    <div class="trigger-content">
      <span class="dropdown-label" *ngIf="label">{{ label }}</span>
      <span class="dropdown-selected-value">{{ selectedOptionLabel }}</span>
    </div>
    <svg class="chevron-icon" [class.rotated]="isOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  </button>

  <div *ngIf="isOpen" class="dropdown-menu">
    <div
      *ngFor="let opt of options"
      class="dropdown-option"
      [class.selected]="opt.value === value"
      (click)="selectOption(opt.value)"
    >
      <span class="option-label">{{ opt.label }}</span>
      <svg *ngIf="opt.value === value" class="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </div>
  </div>
</div>
